import type { ProgramEnrollmentStatus } from '../../../lib/api/program-enrollment.api';

// ─── Qué se puede hacer con una matrícula a programa (H5) ───────────────────
//
// QUIÉN (lo exige el servidor; mostrarle botones a otro cargo sería ofrecerle
// algo que va a fallar):
//   · registrar una matrícula nueva: Registro y administración;
//   · pausar, reactivar, egresar y retirar: Registro, administración y
//     decanato — los mismos que antes de H5 (decisión del PM, 2026-10-16).
//
// QUÉ, según el estado (las mismas transiciones que permite el dominio):
//   · activa     → pausar, egresar, retirar
//   · en pausa   → reactivar, retirar (para egresar, primero se reactiva)
//   · egresada / retirada → nada: son estados finales.

export type ProgramEnrollmentAction = 'pause' | 'reactivate' | 'graduate' | 'withdraw';

export const PROGRAM_ENROLLMENT_REGISTRARS = ['tenantAdmin', 'registrar'] as const;
export const PROGRAM_ENROLLMENT_MANAGERS = ['tenantAdmin', 'registrar', 'academicDean'] as const;

const hasAny = (roles: readonly string[] | undefined, allowed: readonly string[]) =>
  (roles ?? []).some((r) => allowed.includes(r));

/** ¿Puede registrar una matrícula a programa nueva? */
export function canRegisterProgramEnrollment(roles: readonly string[] | undefined): boolean {
  return hasAny(roles, PROGRAM_ENROLLMENT_REGISTRARS);
}

/** ¿Puede pausar, reactivar, egresar y retirar? */
export function canManageProgramEnrollment(roles: readonly string[] | undefined): boolean {
  return hasAny(roles, PROGRAM_ENROLLMENT_MANAGERS);
}

export function programEnrollmentActions(
  status: ProgramEnrollmentStatus,
  canManage: boolean,
): ProgramEnrollmentAction[] {
  if (!canManage) return [];
  if (status === 'active') return ['pause', 'graduate', 'withdraw'];
  if (status === 'on_leave') return ['reactivate', 'withdraw'];
  return [];
}

/** El motivo de un retiro: el mismo mínimo que exige el servidor. */
export const WITHDRAW_REASON_MIN = 10;
